import React from 'react';
import styles from './ShopContainer.module.scss';

/* Interfaces */
import {
  StoreType,
  StoreTypesReversed,
} from '../PaymentGateway/interfaces/store_types';

/* Components */
import { PremiumWrapperConnected } from './Premium/components/PremiumWrapper';
import { TipWrapperConnected } from './Tip/components/TipWrapper';
import { PurchaseStatusProvider } from './shared/__providers__/PurchaseStatusProvider';

import { userSelector } from '../../store/tipster/selector';
import { RootState } from '../../store';
import { connect } from 'react-redux';
import { CredentialsUserObject } from '../../types/Login';

interface ShopContainerProps {
  storeType: StoreType;
  user: CredentialsUserObject;
}

export const ShopContainer: React.FC<ShopContainerProps> = ({
  storeType,
  user,
}) => {
  return (
    <div
      className={styles.container}
      id={
        user && user.is_tipster ? styles.tipsterContainer : styles.userContainer
      }
    >
      <PurchaseStatusProvider>
        {storeType === StoreTypesReversed.Premium && (
          <PremiumWrapperConnected />
        )}
        {storeType === StoreTypesReversed.TipPurchase && (
          <TipWrapperConnected />
        )}
      </PurchaseStatusProvider>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
});

export const ShopContainerConnected = connect(mapStateToProps)(ShopContainer);
